import {Dependencies} from '../types';

export function canChangeOrientation(di: Dependencies = {}): boolean {
  const {wndw = window} = di;
  return typeof wndw.onorientationchange !== 'undefined';
}
